import { createClientConfig } from "@repo/design-system/lib/client-registry";
import Filterbar from "~/components/job-board/filterbar/filterbar-eon";
import { Joblist } from "~/components/job-board/joblist-eon";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import { defaultMjp } from "./default";

export const edgSub = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar,
    Joblist,
  },
  ui: {
    recruiterImageBasePath: "images/recruiter/subclients/edg_sub",
  },
  subtemplates: [defaultMjp],
});

export const edri = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar,
    Joblist,
  },
  ui: {
    recruiterImageBasePath: "images/recruiter/subclients/edri",
  },
  subtemplates: [defaultMjp],
});
